import * as yup from "yup";

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .required("メールアドレスを入力してください")
    .trim()
    .email("メールアドレスの形式で入力してください"),
});

export default validationSchema;
